/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Robot_Hud_IdleInputs */

const en_robot_hud_idle = /** @type {(inputs: Robot_Hud_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No task`)
};

const fr_robot_hud_idle = /** @type {(inputs: Robot_Hud_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune tâche`)
};

const ms_sg2_robot_hud_idle = /** @type {(inputs: Robot_Hud_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada tugasan`)
};

/**
* | output |
* | --- |
* | "No task" |
*
* @param {Robot_Hud_IdleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const robot_hud_idle = /** @type {((inputs?: Robot_Hud_IdleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Robot_Hud_IdleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_robot_hud_idle(inputs)
	if (locale === "fr") return fr_robot_hud_idle(inputs)
	return ms_sg2_robot_hud_idle(inputs)
});